import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface SprinklersProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Sprinklers: React.FC<SprinklersProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [sprinklers, set_sprinklers] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Utilities']?.['Sprinklers'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Utilities': { ...b.values?.['Utilities'], 'Sprinklers': v } } })
    );
    const label = 'Sprinklers';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(sprinklers)}
                />
            ) : (
                <MoneyBox
                    id={'sprinklers'}
                    allowNegative={false}
                    value={sprinklers}
                    onChange={(value) => set_sprinklers(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
